<template>
  <div>
    <v-toolbar v-if="isParlayZone && !isPopularParlaysEmpty">
      <div v-if="!mobileBigAndBelow" class="pp_header">
        <div class="header-title">
          <span class="pp_icon"></span>
          <span class="pp_title">{{ $t('Popular.Parlays.Title') }}</span>
        </div>
      </div>
      <div class="toolbar-items">
        <v-toolbar-items v-for="(filter, index) in filters" :key="index">
          <v-menu v-model="expandedFilters[index]" @click="toggleFilterExpansion(index)" offset-y max-width="320" min-width="180" :left="true" :bottom="true" origin="center" content-class="menu_top_arrow_right">
            <div slot="activator" class="filter-buttons">
              <span class="filter-button-title">{{ filter.name }}</span>
              <div class="filter-button-selected">
                <span>{{ displayParlayType(filter.name) }}</span>
                <v-icon>{{ expandedFilters[index] ? 'expand_less' : 'expand_more' }}</v-icon>
              </div>
            </div>
            <v-list>
              <v-list-tile v-for="(type, typeIndex) in filter.type" :key="typeIndex + 1" @click="selectFilter(filter.name, type)">
                <span>{{ capitalizeText(type, filter.name) }}</span>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-toolbar-items>
      </div>
      <div class="reset-button">
        <button @click="resetFilters">{{ $t('Parlay.Zone.Reset') }}</button>
      </div>
    </v-toolbar>
    <!--    Loader on parlay zone page    -->
    <circle-loader v-if="isLoading && isPopularParlaysEmpty && isParlayZone && !isFeatureTabs" />

    <v-expansion-panel v-if="!isParlayZone || !isPopularParlaysEmpty" class="popular_parlays_holder" v-model="expansionPanel">
      <v-expansion-panel-content :disabled="!isCarouselMode" :class="[{'feature-tab': isFeatureTabs}]">
        <template v-if="isCarouselMode" v-slot:header>
          <div class="pp_header">
            <div class="header-title">
              <span class="pp_icon"></span>
              <span class="pp_title">{{ $t('Popular.Parlays.Title') }}</span>
            </div>
          </div>
          <circle-loader v-if="isLoading && !isParlayZone" />
        </template>

        <v-card class="recomended-parlays" :class="{ 'recommended-one-parlay-only': filteredPopularParlays.length === 1 }">
          <div v-for="parlays in filteredPopularParlays" :key="parlays.IDFWMarketGroup + Math.random()" class="parlays-wrapper" :class="['checkVisibility', { 'one-parlay-only': filteredPopularParlays.length === 1 }]" :data-mgid="parlays.IDFWMarketGroup">
            <popular-parlay :parlays="parlays"/>
          </div>
          <p v-if="!isLoading && isPopularParlaysEmpty">{{ $t('Parlay.Zone.EmptyResponse') }}</p>
          <div v-if="showEmptyFilter" class="filter-empty">{{ $t('Parlay.Zone.EmptyFilter') }}</div>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <div v-if="showEmptyZone && !isLoading" class="empty-zone">
      <p>{{ $t('Parlay.Zone.EmptyResponse') }}</p>
    </div>
  </div>
</template>


<script>
import config from '@/config'
import store from '@/store'
import priceFormat from '@/library/priceFormat'
import BettingOffer from '@/components/mixins/BettingOffer'
import Screen from '@/components/mixins/Screen'
import Gtm from '@/components/mixins/Gtm'
import odds from './PopularParlayOdds.vue'
import handicap from './PopularParlayHcp.vue'
import PopularParlay from './PopularParlay.vue'
import CircleLoader from '@/components/common/CircleLoader'
import lib from '@/library'
import BoNavigationContext from '@/components/mixins/BoNavigationContext'
import lodash from 'lodash'

export default {
  name: 'PopularParlays',
  components: { odds, handicap, PopularParlay, CircleLoader },
  mixins: [
    BettingOffer,
    Gtm,
    Screen,
    BoNavigationContext
  ],
  props: [ 'displayMode', 'eventId', 'isFeatureTabs' ],
  data () {
    return {
      expandedFilters: {},
      parlayStake: 10,
      activeIDFWMarketGroup: null,
      activeParlayBetType: null,
      selectedParlayType: [],
      selectedSportType: [],
      selectedParlayLength: [],
      selectedPotentialReturnAmount: [],
      updateInterval: null,
      isFetchingPopularParlays: false,
      allBetsText: 'Parlay.Zone.AllBets',
      allCountsText: 'Parlay.Zone.AllCounts',
      allSportsText: 'Parlay.Zone.AllSports',
      allTypesText: 'Parlay.Zone.AllTypes',
      allOddsText: 'Parlay.Zone.AllOdds',
      legsText: 'Parlay.Zone.Legs',
      onlyText: 'Parlay.Zone.Only',
      AllText: 'Parlay.Zone.All',
      moreThanText: 'Parlay.Zone.MoreThan',
      filterBetTypeText: 'Parlay.Zone.FilterBetType',
      filterSportText: 'Parlay.Zone.FilterSport',
      filterLegsCountText: 'Parlay.Zone.FilterLegsCount',
      filterTotalOddsText: 'Parlay.Zone.FilterTotalOdds',
      sportsToUpperCase: ['NFL', 'MLB', 'NBA', 'NHL', 'MMA'],
      betTypesToUpperCase: ['SGP', 'SGP+']
    }
  },
  computed: {
    isCarouselMode () {
      return this.displayMode === 'carousel'
    },
    expansionPanel: {
      get () {
        if (this.isFeatureTabs) return 0
        return store.getters['popularParlaysState/getExpansionPanel']
      },
      set (value) {
        if (!this.isFeatureTabs) store.commit('popularParlaysState/setExpansionPanel', value)
      }
    },
    popularParlaysDialogState () {
      return store.getters['overlayState/getPopularParlaysDialogState']
    },
    playerPersonalisationServicePeriodicalUpdate () {
      return config.app.autoconf.PLAYER_PERSONALISATION.periodicalUpdatePrematch
    },
    isLiveAvailableForPopularParlays () {
      return config.app.autoconf.PLAYER_PERSONALISATION.liveEventsAvailableForPopularParlays
    },
    isPopularParlaysEnabled () {
      return config.app.autoconf.PLAYER_PERSONALISATION.enablePopularParlays
    },
    firstInitPopularParlays () {
      return store.getters['getIsFirstInitPopularParlays']
    },
    popularParlays () {
      return store.getters['popularParlaysState/getPopularParlays']
    },
    triggerReload () {
      return store.getters['popularParlaysState/getTriggerPopularParlaysReload']
    },
    uid () {
      return store.getters['getUid'] || localStorage.getItem('customer')
    },
    allParlayTypesActive () {
      return this.selectedParlayType.length === 0
    },
    allSportTypesActive () {
      return this.selectedSportType.length === 0
    },
    allSelectionsActive () {
      return this.selectedParlayLength.length === 0
    },
    allPotentialReturnsActive () {
      return this.selectedPotentialReturnAmount.length === 0
    },
    availableParlayTypes () {
      const parlayTypes = this.popularParlays.map(parlay => lib.personalization.popularParlays.betType(parlay))
      return ['All', ...new Set(parlayTypes)]
    },
    availableSportTypes () {
      const allSports = this.popularParlays.flatMap(sport => sport.SelectionData.map(s => s.market.idfosporttype))
      return ['All', ...new Set(allSports)]
    },
    availableParlayLengths () {
      const parlayLength = this.popularParlays.map(parlay => parlay.SelectionData.length)
      return ['All', ...new Set(parlayLength)].sort((a, b) => a - b)
    },
    availablePotentialReturnsAmount () {
      return ['All', 500, 1000, 2000]
    },
    filteredPopularParlays () {
      return this.popularParlays
        .filter(parlay => this.allParlayTypesActive || lib.personalization.popularParlays.betType(parlay) === this.selectedParlayType[0])
        .filter(parlay => this.allSportTypesActive || parlay.SelectionData.some(selection => selection.market.idfosporttype === this.selectedSportType[0]))
        .filter(parlay => this.allSelectionsActive || parlay.SelectionData.length === this.selectedParlayLength[0])
        .filter(parlay => this.allPotentialReturnsActive ||
          parseInt(this.formatOdds(lib.personalization.popularParlays.parlayPotentialReturn(parlay.BetCalculation.CalculationXP, false))) > this.selectedPotentialReturnAmount ||
          parseInt(this.formatOdds(lib.personalization.popularParlays.parlayPotentialReturn(parlay.BetCalculation.Calculation, false))) > this.selectedPotentialReturnAmount ||
          parseInt(this.formatOdds(lib.personalization.popularParlays.parlayPotentialReturn(parlay.BetCalculation.ProviderCalculation, true))) > this.selectedPotentialReturnAmount
        )
    },
    availableFilters () {
      return config.app.autoconf.PLAYER_PERSONALISATION.availableFilters
    },
    filters () {
      const allFilters = [
        {
          type: this.availableParlayTypes,
          name: this.$t(this.filterBetTypeText)
        },
        {
          type: this.availableSportTypes,
          name: this.$t(this.filterSportText)
        },
        {
          type: this.availableParlayLengths,
          name: this.$t(this.filterLegsCountText)
        },
        {
          type: this.availablePotentialReturnsAmount,
          name: this.$t(this.filterTotalOddsText)
        }
      ]
      return this.availableFilters.map(filterName => {
        return allFilters.find(filter => filter.name === filterName)
      }).filter(Boolean)
    },
    isLoading () {
      return store.getters['popularParlaysState/getIsLoading']
    },
    isPopularParlaysEmpty () {
      return store.getters['popularParlaysState/getIsPopularParlaysEmpty']
    },
    liveEventsLoaded () {
      return store.getters['livebettingState/liveEventsLoaded']
    },
    showEmptyZone () {
      return !this.isCarouselMode && ((this.popularParlays && !this.popularParlays.length) || this.isPopularParlaysEmpty)
    },
    showEmptyFilter () {
      return !this.filteredPopularParlays.length && !this.isCarouselMode && !this.isPopularParlaysEmpty
    },
    isParlayZone () {
      return this.$route.name === 'parlayzone'
    },
    isBetZone () {
      return this.$route.name === 'betzone'
    },
    selectedTab () {
      return store.getters['bonavigationState/getSelectedTab']
    },
    competitions () {
      return this.selectedTab &&
      Array.isArray(this.selectedTab.competitions) &&
      this.selectedTab.competitions.length > 0
        ? this.selectedTab.competitions
        : []
    },
    sportId () {
      return this.sportTypeId
    },
    popularParlaysTriggers () {
      return JSON.stringify({
        a: this.sportId,
        b: this.competitions,
        c: this.isSportsNavigation
      })
    },
    popularParlaysCleanUpTriggers () {
      return JSON.stringify({
        a: this.sportId,
        c: this.isSportsNavigation
      })
    }
  },
  methods: {
    async getPopularParlays (isPeriodical = false) {
      if (!this.isPopularParlaysEnabled) return

      if (this.isFetchingPopularParlays) {
        // console.log('POP - Skipping getPopularParlays, already in progress')
        return
      }

      this.isFetchingPopularParlays = true
      if (this.isFeatureTabs && !isPeriodical) store.commit('featureTabsState/setIsLoading', true)

      try {
        if (this.competitions.length) {
          // console.log('POP - Using competitions for fetch')
          await lib.personalization.popularParlays.fetchPopularParlays(this.uid, null, this.competitions)
        } else if (this.sportId) {
          // console.log('POP - No competitions, using sportId for fetch')
          await lib.personalization.popularParlays.fetchPopularParlays(this.uid, null, null, this.sportId)
        } else if (this.isRootSportsNavigation || this.isParlayZone || this.isBetZone || this.eventId) {
          // console.log('POP - No competitions or sportId, calling with eventId/default')
          await lib.personalization.popularParlays.fetchPopularParlays(this.uid, this.eventId || null)
        } else {
          if (this.isFeatureTabs) store.commit('featureTabsState/setIsLoading', false)
        }
      } catch (error) {
        console.error('POP - Error fetching Popular Parlays:', error)
      } finally {
        this.isFetchingPopularParlays = false
      }
    },
    reloadPopularParlays () {
      if (this.updateInterval) {
        clearInterval(this.updateInterval)
        this.updateInterval = null
        this.startPeriodicalUpdatePopularParlays()
      }
    },
    formatOdds (odds) {
      return priceFormat.formatOdds(odds)
    },
    closePopularParlaysDialog () {
      this.activeIDFWMarketGroup = null
      this.activeParlayBetType = null
      if (this.popularParlaysDialogState && this.popularParlaysDialogState.resolve) {
        this.popularParlaysDialogState.resolve('autoClose')
      } else {
        store.dispatch('overlayState/deactivatePopularParlaysDialogData', false)
      }
    },
    selectFilter (name, type) {
      // this.isExpanded = !this.isExpanded
      if (type === 'All') {
        if (name === 'SPORT') {
          this.selectedSportType = []
        } else if (name === 'BET TYPE') {
          this.selectedParlayType = []
        } else if (name === 'LEG COUNT') {
          this.selectedParlayLength = []
        } else if (name === 'TOTAL ODDS') {
          this.selectedPotentialReturnAmount = []
        }
      } else {
        if (name === 'SPORT') {
          if (this.selectedSportType.includes(type)) {
            this.selectedSportType = this.selectedSportType.filter(t => t !== type)
          } else {
            this.selectedSportType = [type]
          }
        } else if (name === 'BET TYPE') {
          if (this.selectedParlayType.includes(type)) {
            this.selectedParlayType = this.selectedParlayType.filter(t => t !== type)
          } else {
            this.selectedParlayType = [type]
          }
        } else if (name === 'LEG COUNT') {
          if (this.selectedParlayLength.includes(type)) {
            this.selectedParlayLength = this.selectedParlayLength.filter(t => t !== type)
          } else {
            this.selectedParlayLength = [type]
          }
        } else if (name === 'TOTAL ODDS') {
          this.selectedPotentialReturnAmount = [type]
        }
      }
      document.documentElement.scrollIntoView({
        behavior: 'smooth'
      })
    },
    displayParlayType (type) {
      if (type === 'BET TYPE') return this.selectedParlayType.length === 0 ? this.$t(this.allTypesText) : this.betTypesToUpperCase.includes(this.selectedParlayType[0].toUpperCase()) ? this.selectedParlayType[0].toUpperCase() : this.selectedParlayType[0].toLowerCase()
      if (type === 'SPORT') {
        return this.selectedSportType.length === 0 ? this.$t(this.allSportsText) : this.sportsToUpperCase.includes(this.selectedSportType[0].toUpperCase()) ? this.selectedSportType[0].toUpperCase() : this.selectedSportType[0].toLowerCase()
      }
      if (type === 'LEG COUNT') return this.selectedParlayLength.length === 0 ? this.$t(this.allCountsText) : `${this.selectedParlayLength[0].toString().toLowerCase()} ${this.$t(this.onlyText)}`
      if (type === 'TOTAL ODDS') return this.selectedPotentialReturnAmount.length === 0 ? this.$t(this.allOddsText) : `${this.selectedPotentialReturnAmount[0].toString().toLowerCase()}+`
    },
    capitalizeText (text, filterName) {
      if (filterName === 'BET TYPE') {
        return text.toString().split(' ').map(word => {
          const match = this.betTypesToUpperCase.find(type => word.includes(type))
          const transformed = match
            ? word.toUpperCase()
            : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
          if (transformed === 'Parlay') {
            return `${transformed} ${this.$t(this.onlyText)}`
          } else if (transformed === 'All') {
            return `${transformed}`
          }
          return `${transformed} ${this.$t(this.onlyText)}`
        }).join(' ')
      }

      if (filterName === 'LEG COUNT') {
        return text.toString().split(' ').map(word => {
          return word === 'All' ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() + ` ${this.$t(this.legsText)}`
        }).join(' ')
      }
      if (filterName === 'TOTAL ODDS') {
        return text.toString().split(' ').map(word => {
          return word === 'All' ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : `${this.$t(this.moreThanText)} ${word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()}+`
        }).join(' ')
      }
      if (filterName === 'SPORT' && text && typeof text === 'string' && this.sportsToUpperCase.includes(text.toUpperCase())) {
        return text.toUpperCase()
      } else {
        return text.toString().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')
      }
    },
    toggleFilterExpansion (index) {
      this.$set(this.expandedFilters, index, !this.expandedFilters[index])
    },
    resetFilters () {
      this.selectedParlayType = []
      this.selectedPotentialReturnAmount = []
      this.selectedSportType = []
      this.selectedParlayLength = []

      document.documentElement.scrollIntoView({
        behavior: 'smooth'
      })
    },
    startPeriodicalUpdatePopularParlays () {
      if (!this.isPopularParlaysEnabled) return
      if (this.updateInterval) return

      // console.log('POP - Starting Periodic Update for Popular Parlays')

      this.updateInterval = setInterval(() => {
        if (!this.isFetchingPopularParlays) {
          // console.log('POP - Periodic Update for Popular Parlays')
          this.getPopularParlays(true)
        }
      }, this.playerPersonalisationServicePeriodicalUpdate)
    },

    stopPeriodicalUpdatePopularParlays () {
      // console.log('POP - Stopping Periodic Update for Popular Parlays')

      if (!this.updateInterval) return

      clearInterval(this.updateInterval)
      this.updateInterval = null
    },

    delayedPopularParlaysCall () {
      if (!this.delayPopularParlaysCall) {
        // console.log('POP - Creating Debounced Popular Parlays Call')
        this.delayPopularParlaysCall = lodash.debounce(() => this.getPopularParlays(), 10)
      }

      this.delayPopularParlaysCall()
    },

    destroyDelayedPopularParlaysCall () {
      if (this.delayPopularParlaysCall && this.delayPopularParlaysCall.cancel) {
        this.delayPopularParlaysCall.cancel()
      }
    }
  },
  mounted () {
    let storeModule = !this.isFeatureTabs ? 'popularParlaysState' : 'featureTabsState'
    store.commit(`${storeModule}/setIsLoading`, true)
  },
  beforeDestroy () {
    store.commit('popularParlaysState/setPopularParlays', [])
    this.stopPeriodicalUpdatePopularParlays()
    this.destroyDelayedPopularParlaysCall()
  },
  activated () {
  },
  deactivated () {
  },
  watch: {
    sportId () {
      store.commit('popularParlaysState/setPopularParlays', [])
    },
    popularParlaysTriggers: {
      handler () {
        if (this.liveEventsLoaded && this.isPopularParlaysEnabled) {
          // console.log('POP - Popular Parlays Triggers Changed, fetching Popular Parlays...')
          this.delayedPopularParlaysCall()
          this.stopPeriodicalUpdatePopularParlays()
          this.startPeriodicalUpdatePopularParlays()
        }
      },
      immediate: true
    },
    popularParlaysCleanUpTriggers: {
      handler () {
        if (this.liveEventsLoaded && this.isPopularParlaysEnabled) {
          store.commit('popularParlaysState/setPopularParlays', [])
        }
      },
      immediate: true
    },
    popularParlays (newVal) {
      let activeParlay = this.activeIDFWMarketGroup && newVal.find(parlay => parlay.IDFWMarketGroup === this.activeIDFWMarketGroup)

      if (!activeParlay) {
        if (this.activeIDFWMarketGroup) {
          this.closePopularParlaysDialog()
        }
      }
    },
    liveEventsLoaded (newVal) {
      if (newVal) {
        // console.log('POP - Live Events Loaded, fetching Popular Parlays...')
        this.delayedPopularParlaysCall()
        this.startPeriodicalUpdatePopularParlays()
      }
    },
    triggerReload (newVal) {
      if (newVal) {
        clearTimeout(this.triggerReloadTo)
        this.triggerReloadTo = setTimeout(() => {
          this.reloadPopularParlays()
        }, 100)
      }
    },
    isPopularParlaysEmpty (newVal) {
      if (newVal) {
        store.commit('popularParlaysState/setExpansionPanel', null)
      }
    }
  }
}
</script>

<style scoped lang="stylus">
@import "~@/css/config"
.application
  .popular_parlays_holder
    >>>.v-expansion-panel__header
      background  var(--popular-parlays-holder-bgr) !important
      color  var(--popular-parlays-holder-color) !important
      .loader
        flex none
        margin 0 15px 0 0
.popular_parlays_holder
  background var(--popular-parlays-holder-bgr)
  margin 0 5px 5px 0
  box-shadow none !important
  width auto
  @media mobile-big-and-below
    margin 0
  >>>.v-expansion-panel__container--active
    border-bottom 10px solid var(--popular-parlays-holder-bgr)
    @media mobile-big-and-below
      border-bottom 0
  >>>.v-expansion-panel__container--active
    .v-expansion-panel__header
      margin-bottom 0 !important
      min-height 43px
  >>>.v-expansion-panel__container--active.feature-tab
    border-bottom 0
    .v-expansion-panel__header
      display none
  >>>.v-expansion-panel__header
    border none !important
    height 43px
    padding 12px 8px
    @media mobile-big-and-below
      padding-right 2px
    .pp_header
      display flex
      align-items center
      justify-content space-between
      .header-title
        display flex
        align-items center
        //padding-left 15px
        @media mobile-big-and-below
          padding-left 0
      .filter-parlays
        display flex
        padding-right 10px
        @media mobile-big-and-below
          padding-right 2px
        .filter
          border 1px solid #003764
          border-radius 10px
          padding 5px
          min-width 50px
          margin 0 5px
          text-align center
          color #5d6b8a
          font-family 'Roboto Condensed Bold'
          font-size 13px
          text-transform uppercase
          cursor pointer
          height 24px
          display: flex;
          align-items: center;
          justify-content: space-around;
          background #fff
          @media mobile-big-and-below
            margin 0 2px
          &.active
            color #FFF
            background #4a597e
            border none
    .pp_icon
      background var(--pp-icon) 100% center no-repeat
      width 27px
      height 17px
      display inline-flex
      margin-right 10px
      @media mobile-big-and-below
        margin-right 5px
    .pp_title
      font-size 16px
      font-family 'Roboto Condensed Bold'
  >>>.v-expansion-panel__header__icon .v-icon
    color var(--popular-parlays-holder-openclose-icon-color) !important
  >>>.v-expansion-panel__body
    padding-left 5px
  .recommended-one-parlay-only
    justify-content center
  .recomended-parlays
    background var(--popular-parlays-holder-bgr)
    display flex
    overflow-x auto
    margin-left 0
    overflow-y hidden
    padding-bottom 10px
    z-index 5
    color var(--popular-parlays-holder-color)
    scroll-snap-type: x mandatory
    .one-parlay-only
      width 95%
      margin-right 5px
      @media mobile-big-and-below
        width 100%
    .parlays-container
      width 100%
    .parlays-wrapper
      scroll-snap-align: start
.empty-zone
  color var(--popular-parlays-content-color)
</style>



// WEBPACK FOOTER //
// src/components/sports/bettingoffer/popularParlays/PopularParlays.vue